import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { BadgesProvider } from './context/BadgesContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import ChangePassword from './pages/ChangePassword';
import Dashboard from './pages/Dashboard';
import Documents from './pages/Documents';
import DocumentCreate from './pages/DocumentCreate';
import DocumentDetail from './pages/DocumentDetail';
import DocumentEdit from './pages/DocumentEdit';
import Folders from './pages/Folders';
import Training from './pages/Training';
import Users from './pages/Users';
import Groups from './pages/Groups';
import Taxonomy from './pages/Taxonomy';
import ApprovalRoles from './pages/ApprovalRoles';
import Settings from './pages/Settings';
import Audit from './pages/Audit';
import Profile from './pages/Profile';
import Notifications from './pages/Notifications';
import VerifyCopy from './pages/VerifyCopy';
import './styles/global.css';

function ProtectedRoute({ children, requiredRole }) {
  const { user, loading } = useAuth();

  if (loading) return <div className="loading">Carregando...</div>;
  if (!user) return <Navigate to="/login" />;
  if (user.must_change_password) return <Navigate to="/change-password" />;

  if (requiredRole) {
    const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    if (!roles.includes(user.role)) return <Navigate to="/dashboard" />;
  }

  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) return <div className="loading">Carregando...</div>;

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/dashboard" /> : <Login />} />
      <Route path="/change-password" element={<ChangePassword />} />

      {/* Publica: quem chega aqui veio de um QR num papel e nao tem conta.
          Fica FORA do ProtectedRoute de proposito. */}
      <Route path="/verificar" element={<VerifyCopy />} />
      <Route path="/verificar/:code" element={<VerifyCopy />} />

      <Route path="/" element={
        <ProtectedRoute>
          {/* Acima do Layout: tanto o menu quanto as paginas do Outlet
              precisam do mesmo estado de contadores */}
          <BadgesProvider><Layout /></BadgesProvider>
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to="/dashboard" />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="documents" element={<Documents />} />
        <Route path="documents/new" element={<DocumentCreate />} />
        <Route path="documents/:id" element={<DocumentDetail />} />
        <Route path="documents/:id/edit" element={<DocumentEdit />} />
        <Route path="folders" element={<Folders />} />
        <Route path="training" element={<Training />} />
        <Route path="profile" element={<Profile />} />
        <Route path="notifications" element={<Notifications />} />

        {/* Admin + Maintenance */}
        <Route path="groups" element={
          <ProtectedRoute requiredRole={['Administrador', 'Manutencao', 'Auditoria']}><Groups /></ProtectedRoute>
        } />
        <Route path="taxonomy" element={
          <ProtectedRoute requiredRole={['Administrador', 'Manutencao', 'Auditoria']}><Taxonomy /></ProtectedRoute>
        } />
        <Route path="approval-roles" element={
          <ProtectedRoute requiredRole={['Administrador', 'Manutencao', 'Auditoria']}><ApprovalRoles /></ProtectedRoute>
        } />

        {/* Admin only */}
        <Route path="users" element={
          <ProtectedRoute requiredRole={['Administrador', 'Auditoria']}><Users /></ProtectedRoute>
        } />
        <Route path="settings" element={
          <ProtectedRoute requiredRole={['Administrador', 'Auditoria']}><Settings /></ProtectedRoute>
        } />
        <Route path="audit" element={
          <ProtectedRoute requiredRole={['Administrador', 'Auditoria']}><Audit /></ProtectedRoute>
        } />
      </Route>

      <Route path="*" element={<Navigate to="/dashboard" />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
